import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { TextField } from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import {
  StyledDiv,
  SpacingBottom,
} from 'containers/AppContainer/Dialogs/styles';
import DialogMission from 'containers/ExpertExpertise/Dialogs/index';
import { translate } from 'containers/services/translate';
import messages from 'containers/AppContainer/messages';

export interface UnlockClaimDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  validateDialog: Function;
}

const UnlockClaimDialog: React.FC<UnlockClaimDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;
  const [claimNumber, setClaimNumber] = useState(null);
  /* istanbul ignore next */
  const successCallBack = () => {
    toast.success(
      translate(messages.unlockClaimSuccessToast, props, {
        claimNumber: claimNumber,
      }),
    );
    props.onClose();
  };

  /* istanbul ignore next */
  const onSubmit = () => {
    props.validateDialog(
      {
        claimNumber: claimNumber,
      },
      successCallBack,
    );
  };
  /* istanbul ignore next */
  const handleChange = (event: any) => {
    setClaimNumber(event.target.value);
  };

  return (
    <DialogMission
      open={open}
      onClose={onClose}
      validateDialog={onSubmit}
      title={translate({ ...messages.unlockClaim }, props)}
      content={
        <StyledDiv>
          <div style={SpacingBottom}>
            {translate({ ...messages.unlockClaimDialogDescription }, props)}
          </div>
          <TextField
            onChange={handleChange}
            name={'claimNumber'}
            value={claimNumber}
            label={translate(
              { ...messages.unlockClaimDialogLabelInput },
              props,
            )}
            className="input"
            multiline
            fullWidth
          />
        </StyledDiv>
      }
      disabled={!claimNumber}
    />
  );
};

UnlockClaimDialog.defaultProps = {
  open: false,
};

export default injectIntl(UnlockClaimDialog);
